import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import Dexie from 'dexie';
import Swal from 'sweetalert2';
import { TblCatUsuario } from 'src/app/types/Tables';
import { EstacionesTVADB } from 'src/app/DAO/EstacionesTVADB';
import { MasterDB } from 'src/app/DAO/MasterDB';
import { Utilerias } from 'src/app/helpers/Utilerias';
import { MenuItem } from 'src/app/types/type';
import { LoginService } from 'src/app/services/login.service';
declare var $: any;

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent {
  userSesion: TblCatUsuario;
  moduleName: string;
  menus: MenuItem[];
  db: EstacionesTVADB;
  existeToken: boolean;

  constructor(private loginService: LoginService, private router: Router, private location: Location, private http: HttpClient) {
    this.existeToken = false;
  }

  async ngOnInit() {
    this.userSesion = await MasterDB.getUsuarioSesion(new EstacionesTVADB());
    this.loginService.getCatalogoMenus(this.userSesion.IdEmpleado)
      .subscribe(resp => {
        if (resp.Result.Exito) {
          this.menus = resp.Result.Data as MenuItem[];
          const urlActual = this.router.url.replace('/', '');;
          const isAuthorized = this.menus.find(item => item.ComponentName === urlActual);

          if (isAuthorized === undefined)
            this.location.back();

          this.showMessageWelcome();
        }
      })
  }

  showMessageWelcome() {
    if (!localStorage["MessageWelcome"]) {
      Swal.fire({
        title: 'Bienvenido',
        text: 'Se recomienda el uso adecuado de la aplicación, cualquier uso indebido será sancionado.'
      })
        .then(res => {
          if (res.value) {
            localStorage["MessageWelcome"] = 1;
          }
        })
    }
  }

  private async existsSesion() {
    return await Dexie.exists('EstacionesTVA')
  }

  async cierreSesion() {
    const confirm = await Utilerias.alertConfirm('¿Deseas cerrar sesion?')
    if (confirm.value) {
      const { IdEmpleado } = await MasterDB.getUsuarioSesion(new EstacionesTVADB());

      this.loginService.deleteTranControlSesionUsuario(IdEmpleado)
        .subscribe(resp => {
          if (resp.Result.Exito)
            this.redirectSesion();
        });
    }
  }

  private async redirectSesion() {
    const config: any = await Utilerias.httpRequest(this.http, 'GetCatalogoAppSettings');
    let site = config.login_UrlRedirect;
    await Dexie.delete('EstacionesTVA');

    if (config.debug == "true") {
      localStorage.clear();
    } else {
      site = config.login_UrlSalirOkta;
      localStorage.clear();
    }
    window.location.href = site;
  }

  userInfo() {
    if ($('#dropdown-menu').is(':visible')) {
      $('#dropdown-menu').fadeOut();
    } else {
      $('#dropdown-menu').fadeIn();
    }
  }
}
